// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a0144505","821":"3191a4a4"}[chunkId] + ".chunk.js";
};